type TGlobal = {
  app: {
    isInitProcess: boolean;
  };
  api: {
    terminalDeviceId?: string | undefined;
  };
  navigation: {
    initialMountingPath: string;
    isAlreadySetInitialMountingPath: boolean;
  };
  explore: {
    isCustomFiltersSet: boolean;
  };
};

export const GLOBALS_DEFAULTS: TGlobal = {
  app: {
    isInitProcess: false
  },
  api: {
    terminalDeviceId: undefined
  },
  navigation: {
    initialMountingPath: '/',
    isAlreadySetInitialMountingPath: false
  },
  explore: {
    isCustomFiltersSet: false
  }
};

export const GLOBALS: TGlobal = JSON.parse(JSON.stringify(GLOBALS_DEFAULTS));
